import { render, staticRenderFns } from "./Documentacion-se.vue?vue&type=template&id=4f4f60fb&"
import script from "./Documentacion-se.vue?vue&type=script&lang=js&"
export * from "./Documentacion-se.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports